import { render } from "./copy-form.vue?vue&type=template&id=0430d5c2&scoped=true"
import script from "./copy-form.vue?vue&type=script&lang=js"
export * from "./copy-form.vue?vue&type=script&lang=js"

import "./copy-form.vue?vue&type=style&index=0&id=0430d5c2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0430d5c2"]])

export default __exports__